import getPriceMode from "./getPriceMode";
import { GetHeaderLeft, GetHeaderRight } from "@navigations/utils";
import { getHeaderStyleBasedOnProduct } from "@components/common/Header/utils";
import Routes from "@navigations/Routes";
import { ProductCategory } from "@utils/constants";
import { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";

// Space taken by headerLeft/headerRight buttons (24px icon + 16px padding on
// both sides), so a long centered title never runs under them.
const HEADER_ACTION_WIDTH = 56;
const HEADER_TITLE_GAP = 8;
const MIN_HEADER_TITLE_WIDTH = 120;

const getHeaderTitleMaxWidth = () => {
  const { deviceWidth } = useIsFoldable();

  return Math.max(
    MIN_HEADER_TITLE_WIDTH,
    deviceWidth - 2 * (HEADER_ACTION_WIDTH + HEADER_TITLE_GAP)
  );
};

const getHeaderScreenOptions = ({
  route,
  showHeader = true,
  user,
  activeProduct,
  typography,
  theme,
}: any) => {
  const headerColorBasedOnActiveProductRoutes = [
    Routes.RequestDetailScreen,
    Routes.RequestModifyScreen,
    Routes.FilterScreen,
    Routes.FilterSearchScreen,
    Routes.FindMatchScreen,
    Routes.PDPScreen,
    Routes.SearchResultScreen,
    Routes.FilterSplitScreen,
    Routes.BulkRequestScreen,
    Routes.BulkInitScreen,
    Routes.ReviewPage,
  ];
  const focusedRouteName = route.name;
  const { background, textColor } = getHeaderStyleBasedOnProduct(
    focusedRouteName &&
      headerColorBasedOnActiveProductRoutes.includes(focusedRouteName)
      ? activeProduct
      : ProductCategory.DEFAULT,
    theme
  );

  const priceModeConfig = getPriceMode({
    focusedRouteName,
    background,
    textColor,
    user,
    theme,
  });

  return {
    headerShown: showHeader,
    headerTitleStyle: {
      ...typography["H2-M"],
      maxWidth: getHeaderTitleMaxWidth(),
    },
    headerTitleAlign: "center",
    headerTitleAllowFontScaling: false,
    headerLeft: () => <GetHeaderLeft textColor={textColor} />,
    headerRight: () => (
      <GetHeaderRight color={textColor} focusedRouteName={focusedRouteName} />
    ),
    ...(!theme.isLargeScreen && priceModeConfig),
  } as NativeStackNavigationOptions;
};

export default getHeaderScreenOptions;
